import { observer } from "mobx-react";
import React from "react";

import { useTranslation } from "react-i18next";

import TeamIcon from "@components/icons/TeamIcon";
import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";
import { mergeStreakStats } from "@utils/statistics/utils-statistics";

import { HeadToHeadItem } from "./HeadToHeadItem";

export const HeadToHead = observer(function HeadToHead(props: {
	title: string;
	data: StreakStat[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) {
	const { data, title, tournament, homeTeam, awayTeam } = props;
	const { t } = useTranslation();

	if (!data) return null;

	const mergedData = mergeStreakStats(data);

	const homeIcon = (
		<TeamIcon
			showCountryFlag={tournament?.showCountryFlag}
			flagCode={homeTeam?.countryCode}
			jerseyTypeAbrv={homeTeam?.jerseyTypeAbrv}
			opponentFlagCode={awayTeam?.countryCode}
			opponentJerseyTypeAbrv={awayTeam?.jerseyTypeAbrv}
			className="card--stats__icon u-icon--big"
		/>
	);

	const awayIcon = (
		<TeamIcon
			showCountryFlag={tournament?.showCountryFlag}
			flagCode={awayTeam?.countryCode}
			jerseyTypeAbrv={awayTeam?.jerseyTypeAbrv}
			opponentFlagCode={homeTeam?.countryCode}
			opponentJerseyTypeAbrv={homeTeam?.jerseyTypeAbrv}
			className="card--stats__icon u-icon--big"
		/>
	);

	return (
		<div className="statistics__card">
			<div className="statistics__header">
				<span className="statistics__title">{title}</span>
			</div>
			<div className="statistics__body">
				<div className="statistics__row">
					<div className="statistics__col">
						<div className="statistics__team">
							{homeIcon}
							<span className="statistics__name statistics__name--left">
								{t("EVENT.OFFER.COMPETITOR_HOME")}
							</span>
						</div>
					</div>
					<div className="statistics__col">
						<div className="statistics__team">
							<span className="statistics__name statistics__name--right">
								{t("EVENT.OFFER.COMPETITOR_AWAY")}
							</span>
							{awayIcon}
						</div>
					</div>
				</div>

				{mergedData.map((item, index) => (
					<HeadToHeadItem key={index} item={item} />
				))}
			</div>
		</div>
	);
});
